import { useState, useEffect } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "@/components/ScrollToTop";
import WhatsAppButton from "@/components/shared/WhatsAppButton";
import BackToTop from "@/components/shared/BackToTop";
import StickyQuoteCTA from "@/components/shared/StickyQuoteCTA";
import ExitIntentPopup from "@/components/shared/ExitIntentPopup";
import ChatbotWidget from "@/components/shared/ChatbotWidget";

import RecentlyViewed from "@/components/shared/RecentlyViewed";
import QuoteBuilder, { QuoteBuilderProvider } from "@/components/shared/QuoteBuilder";
import ScrollCTA from "@/components/shared/ScrollCTA";
import RamadanLoader from "@/components/RamadanLoader";
import Index from "./pages/Index";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import ProductCustomization from "./pages/ProductCustomization";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import Sustainability from "./pages/Sustainability";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Careers from "./pages/Careers";
import ContactPage from "./pages/ContactPage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => {
  const [showLoader, setShowLoader] = useState(true);

  const handleLoaderComplete = () => {
    setShowLoader(false);
  };

  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <QuoteBuilderProvider>
            <Toaster />
            <Sonner />
            {showLoader && <RamadanLoader onComplete={handleLoaderComplete} />}
            <BrowserRouter>
              <ScrollToTop />
              
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:productId" element={<ProductDetail />} />
                <Route path="/products/customization" element={<ProductCustomization />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/:serviceId" element={<ServiceDetail />} />
                <Route path="/sustainability" element={<Sustainability />} />
                <Route path="/about" element={<About />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
              <WhatsAppButton />
              <BackToTop />
              <StickyQuoteCTA />
              <ExitIntentPopup />
              <ChatbotWidget />
              <RecentlyViewed />
              <QuoteBuilder />
              <ScrollCTA />
            </BrowserRouter>
          </QuoteBuilderProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
